import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1b533a0f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Entry Ends: ", -1))
const _hoisted_3 = { key: 1 }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Ended: ", -1))
const _hoisted_5 = { class: "controls" }
const _hoisted_6 = { class: "info" }

import FactionImage from '@/components/Faction/FactionImage.vue';
import Button from '@/components/UI/Button.vue';
import { Faction, FactionPrivacy } from '@/typings/faction';
import { computed, inject, toRefs } from 'vue';
import { useRouter } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  props: {
    faction: null
  },
  emits: ['join'],
  setup(__props: any) {

const props = __props as {
  faction: Faction;
}



const isPublicView = inject('isPublicView');



const { faction } = toRefs(props);

const isLimited = computed(() => status.value === 'Event');

const status = computed(() => {
  if (faction.value.EventCount > 0) {
    return 'Event';
  }
  switch (faction.value.Privacy) {
    case FactionPrivacy.InviteOnly:
      return 'Invite Only';
    case FactionPrivacy.Public:
      return 'Public';
    default:
      return 'Private';
  }
});

const factionTypeClass = computed(() => {
  if (faction.value.EventCount > 0) {
    return 'limited';
  }
  switch (faction.value.Privacy) {
    case FactionPrivacy.InviteOnly:
      return 'invite';
    case FactionPrivacy.Public:
      return 'public';
    default:
      return 'private';
  }
});

const entryEnds = computed(() =>
  props.faction.EntryEnds
    ? new Date(props.faction.EntryEnds).toLocaleString()
    : ''
);

const closedAt = computed(() =>
  props.faction.ClosedAt
    ? new Date(props.faction.ClosedAt).toLocaleString()
    : ''
);

const router = useRouter();

function view() {
  router.push({
    name: 'Faction',
    params: { factionId: props.faction.Uuid },
  });
}

return (_ctx: any,_cache: any) => {
  const _component_fa_icon = _resolveComponent("fa-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["faction", _unref(factionTypeClass)])
  }, [
    _createElementVNode("div", null, [
      _createVNode(FactionImage, {
        class: "image",
        faction: _unref(faction)
      }, null, 8, ["faction"])
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("span", null, _toDisplayString(_unref(faction).Name), 1),
      _createElementVNode("div", {
        class: _normalizeClass(["description", { limited: _unref(isLimited) }])
      }, _toDisplayString(_unref(faction).Description), 3),
      (_unref(isLimited))
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (_unref(entryEnds) && !_unref(closedAt))
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                  _hoisted_2,
                  _createTextVNode(_toDisplayString(_unref(entryEnds)), 1)
                ]))
              : _createCommentVNode("", true),
            (_unref(closedAt))
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _hoisted_4,
                  _createTextVNode(_toDisplayString(_unref(closedAt)), 1)
                ]))
              : _createCommentVNode("", true)
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_fa_icon, {
          icon: "user",
          class: "mr-2"
        }),
        _createTextVNode(_toDisplayString(_unref(faction).MemberCount), 1)
      ]),
      (!_unref(isPublicView))
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (!_unref(faction).Joined)
              ? (_openBlock(), _createBlock(Button, {
                  key: 0,
                  class: "text-sm",
                  title: "Join",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('join', _unref(faction))))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_fa_icon, { icon: "plus" })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_unref(faction).Joined || _unref(faction).Privacy === 1)
              ? (_openBlock(), _createBlock(Button, {
                  key: 1,
                  class: "text-sm enter",
                  title: "View",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (view()))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_fa_icon, { icon: "eye" })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ], 64))
        : _createCommentVNode("", true)
    ])
  ], 2))
}
}

})